import moment from 'moment'

export function formatDate(dateString) {
	return moment(dateString).format("MMM Do YYYY")
}
export function formatDayForEventStub(dateString) {
	return moment(dateString).format("ddd").toUpperCase()
}
export function formatDateForEventStub(dateString) {
	return moment(dateString).format("MMM D").toUpperCase()
}
export function formatTimeForEventStub(dateString) {
	return moment(dateString).format("h:mmA").toUpperCase()
}
export function formatDateForFeaturedLink(dateString) {
	return moment(dateString).format("MMM D")
}

export function convertDateMomentToFullDate(dateMoment) {
	let year = dateMoment.year()
	let month = dateMoment.month()
	let date = dateMoment.date()
	let fullDate = new Date(year, month, date)
	return fullDate
}

export function combineDayAndTimeToFullDate(dayMoment, timeMoment) {
	let year = dayMoment.year()
	let month = dayMoment.month()
	let day = dayMoment.date()
	let hour = timeMoment.hour()
	let minute = timeMoment.minute()
	let fullDate = new Date(year, month, day, hour, minute)
	return fullDate
}

export function stripStylesFromHtmlString(markupString) {
	//create a temp div to "hang" the rest of the nodes from
	let wrapper = document.createElement('tempWrapper')
	//hang the input string's html/markup from the wrapper
	wrapper.innerHTML = markupString
	//parse the HTMLified DOM to remove styles
	removeStyles(wrapper)
	//now that styles are removed, grab the HTMLified DOM as a string
	return wrapper.outerHTML
}

function removeStyles(htmlEl) {
	htmlEl.removeAttribute('style')
	if (htmlEl.childNodes.length > 0) {
		for (let child in htmlEl.childNodes) {
			if (htmlEl.childNodes[child].nodeType === 1) {
				removeStyles(htmlEl.childNodes[child])
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/helpers.js